import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const Container = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 188px;
  height: 48px;
  background-color: ${themeGet('colors.white')};
  cursor: pointer;
  border-radius: 12px;

  iframe {
    transform: scale(0.7);
  }

  .clutch-widget,
  .clutch-widget * {
    pointer-events: none !important;
  }
  .clutch-widget iframe {
    pointer-events: none !important;
  }
`
